let childSession = false;

/** Client code calls this when a child session becomes the active session, and again when it ends. */
export function setChildSessionActive(active: boolean): void {
  if (childSession === active) return;
  childSession = active;
  for (const listener of listeners) listener(active);
}

const listeners = new Set<(active: boolean) => void>();

/** Runs on each change, so a shell outside the page (the desktop main process) can mirror the state. */
export function onChildSessionChange(listener: (active: boolean) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Client telemetry passes events through here: while a child session is active, nothing leaves the
 * device (no error events, breadcrumbs or replay).
 */
export function withoutChildSessionTelemetry<T>(item: T): T | null {
  return childSession ? null : item;
}
